module.exports = __webpack_public_path__ + "static/media/3655.788bb4d0.jpg";